import { InformationSymbolIcon } from './InformationSymbolIcon';

/**
 * author: Jeff Anders
 * id EAA6E06D-B798-4198-BF74-3B31F564A807
 * name information-symbol
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-symbol.svg
 * tags
 * - Settings 
 */
export const InfoSymbolIcon = InformationSymbolIcon;
export default InfoSymbolIcon